
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93e1ts2FOFIqMeta } from "/tmp/menaceking-build-1751899079/pages/[...slug].vue?macro=true";
import { default as autologin44v0QNsDrBMeta } from "/tmp/menaceking-build-1751899079/pages/auth/autologin.vue?macro=true";
import { default as callbackQy7XakMmSgMeta } from "/tmp/menaceking-build-1751899079/pages/auth/social/[connection]/callback.vue?macro=true";
import { default as bettingJ6lbXjKSNiMeta } from "/tmp/menaceking-build-1751899079/pages/betting.vue?macro=true";
import { default as _91pageIdentity_93CJaHnIYdc7Meta } from "/tmp/menaceking-build-1751899079/pages/bonus/[pageIdentity].vue?macro=true";
import { default as _91categoryIdentity_93SEnikWaSUKMeta } from "/tmp/menaceking-build-1751899079/pages/categories/[categoryIdentity].vue?macro=true";
import { default as categoriesmVK3HnCEIqMeta } from "/tmp/menaceking-build-1751899079/pages/categories.vue?macro=true";
import { default as contactGMaRqr43ftMeta } from "/tmp/menaceking-build-1751899079/pages/contact.vue?macro=true";
import { default as favorites_46clientwl1TBMig2lMeta } from "/tmp/menaceking-build-1751899079/pages/favorites.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/tmp/menaceking-build-1751899079/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91id_93gyEAOwZY4jMeta } from "/tmp/menaceking-build-1751899079/pages/games/[id].vue?macro=true";
import { default as indexbFeJWO7tFtMeta } from "/tmp/menaceking-build-1751899079/pages/index.vue?macro=true";
import { default as loyalty5GogIppDKoMeta } from "/tmp/menaceking-build-1751899079/pages/loyalty.vue?macro=true";
import { default as mainaKsmF2axKgMeta } from "/tmp/menaceking-build-1751899079/pages/main.vue?macro=true";
import { default as bonusesnOI37z2oq3Meta } from "/tmp/menaceking-build-1751899079/pages/profile/bonuses.vue?macro=true";
import { default as documents5LFY2DV5dFMeta } from "/tmp/menaceking-build-1751899079/pages/profile/documents.vue?macro=true";
import { default as historyGlWcYdO4SdMeta } from "/tmp/menaceking-build-1751899079/pages/profile/history.vue?macro=true";
import { default as infoWC7Q0ezslSMeta } from "/tmp/menaceking-build-1751899079/pages/profile/info.vue?macro=true";
import { default as limitsm22Xau7o4pMeta } from "/tmp/menaceking-build-1751899079/pages/profile/limits.vue?macro=true";
import { default as notificationsPxiF99ONaVMeta } from "/tmp/menaceking-build-1751899079/pages/profile/notifications.vue?macro=true";
import { default as securitybZ1p4N889fMeta } from "/tmp/menaceking-build-1751899079/pages/profile/security.vue?macro=true";
import { default as verificationHaKrvo68N1Meta } from "/tmp/menaceking-build-1751899079/pages/profile/verification.vue?macro=true";
import { default as walletOJLMb7DURUMeta } from "/tmp/menaceking-build-1751899079/pages/profile/wallet.vue?macro=true";
import { default as profile_46clientIqRaLr3ILLMeta } from "/tmp/menaceking-build-1751899079/pages/profile.client.vue?macro=true";
import { default as providers8bYhUFNyr0Meta } from "/tmp/menaceking-build-1751899079/pages/providers.vue?macro=true";
import { default as _91pageIdentity_93RgwesgXgBYMeta } from "/tmp/menaceking-build-1751899079/pages/questions/[pageIdentity].vue?macro=true";
import { default as questionsqEnSnRdoG7Meta } from "/tmp/menaceking-build-1751899079/pages/questions.vue?macro=true";
import { default as recently_45played_46clientmIB3u6GGKVMeta } from "/tmp/menaceking-build-1751899079/pages/recently-played.client.vue?macro=true";
import { default as _91pageIdentity_93m3ntzgyhRYMeta } from "/tmp/menaceking-build-1751899079/pages/static/[pageIdentity].vue?macro=true";
import { default as _91identity_93xMKctXdTaEMeta } from "/tmp/menaceking-build-1751899079/pages/tournaments/[identity].vue?macro=true";
import { default as indexBP3bilvg7RMeta } from "/tmp/menaceking-build-1751899079/pages/tournaments/index.vue?macro=true";
import { default as welcome_45packagefcRb4fCJjwMeta } from "/tmp/menaceking-build-1751899079/pages/welcome-package.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/tmp/menaceking-build-1751899079/pages/[...slug].vue")
  },
  {
    name: "auth-autologin",
    path: "/auth/autologin",
    component: () => import("/tmp/menaceking-build-1751899079/pages/auth/autologin.vue")
  },
  {
    name: "auth-social-connection-callback",
    path: "/auth/social/:connection()/callback",
    component: () => import("/tmp/menaceking-build-1751899079/pages/auth/social/[connection]/callback.vue")
  },
  {
    name: "betting",
    path: "/betting",
    component: () => import("/tmp/menaceking-build-1751899079/pages/betting.vue")
  },
  {
    name: "bonus-pageIdentity",
    path: "/bonus/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751899079/pages/bonus/[pageIdentity].vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: categoriesmVK3HnCEIqMeta || {},
    component: () => import("/tmp/menaceking-build-1751899079/pages/categories.vue"),
    children: [
  {
    name: "categories-categoryIdentity",
    path: ":categoryIdentity()",
    component: () => import("/tmp/menaceking-build-1751899079/pages/categories/[categoryIdentity].vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/tmp/menaceking-build-1751899079/pages/contact.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751899079/pages/favorites.client.vue"))
  },
  {
    name: "games-id",
    path: "/games/:id()",
    component: () => import("/tmp/menaceking-build-1751899079/pages/games/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/menaceking-build-1751899079/pages/index.vue")
  },
  {
    name: "loyalty",
    path: "/loyalty",
    component: () => import("/tmp/menaceking-build-1751899079/pages/loyalty.vue")
  },
  {
    name: "main",
    path: "/main",
    component: () => import("/tmp/menaceking-build-1751899079/pages/main.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751899079/pages/profile.client.vue")),
    children: [
  {
    name: "profile-bonuses",
    path: "bonuses",
    component: () => import("/tmp/menaceking-build-1751899079/pages/profile/bonuses.vue")
  },
  {
    name: "profile-documents",
    path: "documents",
    component: () => import("/tmp/menaceking-build-1751899079/pages/profile/documents.vue")
  },
  {
    name: "profile-history",
    path: "history",
    component: () => import("/tmp/menaceking-build-1751899079/pages/profile/history.vue")
  },
  {
    name: "profile-info",
    path: "info",
    component: () => import("/tmp/menaceking-build-1751899079/pages/profile/info.vue")
  },
  {
    name: "profile-limits",
    path: "limits",
    component: () => import("/tmp/menaceking-build-1751899079/pages/profile/limits.vue")
  },
  {
    name: "profile-notifications",
    path: "notifications",
    component: () => import("/tmp/menaceking-build-1751899079/pages/profile/notifications.vue")
  },
  {
    name: "profile-security",
    path: "security",
    component: () => import("/tmp/menaceking-build-1751899079/pages/profile/security.vue")
  },
  {
    name: "profile-verification",
    path: "verification",
    component: () => import("/tmp/menaceking-build-1751899079/pages/profile/verification.vue")
  },
  {
    name: "profile-wallet",
    path: "wallet",
    component: () => import("/tmp/menaceking-build-1751899079/pages/profile/wallet.vue")
  }
]
  },
  {
    name: "providers",
    path: "/providers",
    component: () => import("/tmp/menaceking-build-1751899079/pages/providers.vue")
  },
  {
    name: "questions",
    path: "/questions",
    meta: questionsqEnSnRdoG7Meta || {},
    component: () => import("/tmp/menaceking-build-1751899079/pages/questions.vue"),
    children: [
  {
    name: "questions-pageIdentity",
    path: ":pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751899079/pages/questions/[pageIdentity].vue")
  }
]
  },
  {
    name: "recently-played",
    path: "/recently-played",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751899079/pages/recently-played.client.vue"))
  },
  {
    name: "static-pageIdentity",
    path: "/static/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751899079/pages/static/[pageIdentity].vue")
  },
  {
    name: "tournaments-identity",
    path: "/tournaments/:identity()",
    component: () => import("/tmp/menaceking-build-1751899079/pages/tournaments/[identity].vue")
  },
  {
    name: "tournaments",
    path: "/tournaments",
    component: () => import("/tmp/menaceking-build-1751899079/pages/tournaments/index.vue")
  },
  {
    name: "welcome-package",
    path: "/welcome-package",
    component: () => import("/tmp/menaceking-build-1751899079/pages/welcome-package.vue")
  }
]